import React from 'react';
import { Link } from 'react-router-dom';
import { useChatroom } from '../../context/ChatroomContext';

export default function ChatroomBell() {
  const { state } = useChatroom() || {};
  if (!state?.access?.allowed) return null;
  const unread = state.notifications.filter(item => !item.readAtMs).sort((a, b) => a.createdAtMs - b.createdAtMs);
  const count = state.unreadCount ?? unread.length;
  const next = unread[0];
  const target = next ? `/chatroom?post=${encodeURIComponent(next.messageId)}&mention=${encodeURIComponent(next.id)}` : '/chatroom';
  return <Link to={target} className="chat-bell relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white hover:border-white/60"
    aria-label={count ? `Chatroom: ${count} unread mentions` : 'Chatroom notifications'} title="Chatroom notifications">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" /></svg>
    {count > 0 && <span className="chat-mention-count absolute -right-1 -top-1 rounded-full px-1 text-[10px] font-bold" style={{ color: '#ff5757', background: '#160707', border: '1px solid #e84040', minWidth: 18, textAlign: 'center' }}>{count}</span>}
  </Link>;
}
